import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AggregatedData } from "types/AggregatedData";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchAggregatedData = createAsyncThunk(
	"aggregatedData/fetch",
	apiGet<AggregatedData>(
		(authConfig) => authConfig.DATA_LAKE_API_ENDPOINTS.GET_AGGREGATED_DATA(),
		[SCOPES.DATA_LAKE_READ],
	),
);
